import { CopyIcon, Trash2 } from 'lucide-react'

interface ApiKeyRowProps {
  name: string
  key: string
  lastUsed: string
  apiKey: string
  onDelete: () => void
  onCopy: () => void
}

export function ApiKeyRow({
  name,
  key,
  lastUsed,
  onDelete,
  onCopy,
  apiKey,
}: ApiKeyRowProps) {
  return (
    <div className="grid grid-cols-[1fr_1fr_1.2fr] items-center gap-4 p-4 hover:bg-gray-50">
      <div className="text-sm font-[400] text-gray-900">{name}</div>
      <div className="text-sm font-[400] text-gray-900">{lastUsed}</div>

      <div className="flex items-center justify-between gap-[24px]">
        <div className="flex w-[90%] items-center space-x-2">
          <code className=" w-[135px] rounded bg-gray-100 px-2 py-1 text-sm text-gray-900">
            {'•'.repeat(apiKey.length - 12) + apiKey.slice(-4)}
          </code>
          <button
            onClick={onCopy}
            className="text-gray-400 hover:text-gray-600"
            title="Copy API key"
          >
            <CopyIcon size={16} />
          </button>
        </div>
        <button
          onClick={onDelete}
          className="text-red-400 hover:text-red-600"
          title="Delete API key"
        >
          <Trash2 size={16} />
        </button>
      </div>
    </div>
  )
}
